var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluecalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 0C13.5383 0 14.625 1.08672 14.625 2.4375V6.5H30.875V2.4375C30.875 1.08672 31.9617 0 33.3125 0C34.6633 0 35.75 1.08672 35.75 2.4375V6.5H39C42.5851 6.5 45.5 9.41484 45.5 13V42.25C45.5 45.8352 42.5851 48.75 39 48.75H6.5C2.91484 48.75 0 45.8352 0 42.25V13C0 9.41484 2.91484 6.5 6.5 6.5H9.75V2.4375C9.75 1.08672 10.8367 0 12.1875 0ZM12.1875 11.375H6.5C5.60625 11.375 4.875 12.1062 4.875 13V17.875H40.625V13C40.625 12.1062 39.8937 11.375 39 11.375H12.1875ZM4.875 22.75V42.25C4.875 43.1437 5.60625 43.875 6.5 43.875H39C39.8937 43.875 40.625 43.1437 40.625 42.25V22.75H4.875Z",
    fill: "#1F3C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluecalendar);
export default __webpack_public_path__ + "static/media/bluecalendar.c8f3be89616607433ca3f363d290dac4.svg";
export { ForwardRef as ReactComponent };